import * as R from "ramda";

export const getDescription = R.prop("description");
